module.exports = __webpack_public_path__ + "img/va_kio_yat_po_offices.d020c429.jpg";